export const subFields = [
  {
    id: 'packing_list_no',
    label: 'Уп. лист',
    value: 'packing_list_no'
  }
]
